// src/cloudinary.js
import { Cloudinary } from "@cloudinary/url-gen";

const cld = new Cloudinary({ cloud: { cloudName: 'dzsqhh2hh', }, });


export default cld;
